import PropTypes from 'prop-types'

import { getTextFromSelectedDropdownOption } from 'utils/formatters'
import { getDisplayName, getUrlParam } from 'utils/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location } = props

    const getStartOrderModalSubmittedParameters = ({
      retailerOptions,
      collectionOptions,
      selectedCollectionId,
      eventsOptions,
      selectedOrderEventId,
    }) => ({
      Retailer: getTextFromSelectedDropdownOption(
        retailerOptions,
        props.selectedRetailerId,
      ),
      Linesheet: getTextFromSelectedDropdownOption(
        collectionOptions,
        selectedCollectionId,
      ),
      Event: getTextFromSelectedDropdownOption(
        eventsOptions,
        selectedOrderEventId,
      ),
      ...getUrlParam(location),
    })

    const trackers = {
      trackStartOrderModalSubmitted: (config) =>
        mixpanel.track(
          'Orders List_Start Web Order Submitted',
          getStartOrderModalSubmittedParameters(config),
        ),
      trackStartOrderModalCancelled: () =>
        mixpanel.track('Orders List_Start Web Order Cancelled'),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
